import { TeIcon } from '@topcon/tuicl-react';

/**
 * Business Partner icon cell: the header-less first column of the Customers
 * (02), Invites (03) and Requests (04) tables, next to the name column (Figma
 * 6030:24276). No uploaded-icon support yet, so a generic `business` icon
 * stands in for every row.
 */
export default function BusinessPartnerIconCell() {
  return <TeIcon name="business" size="m" color="icon.primary" />;
}
